import update from 'immutability-helper';

const initialState = {
  redirectURL: '',
  newUploadDocumentType: '',
  newUploadSessionHash: '',
  newUploadSessionKey: '',
  defaultDropTrackingDisabled: false,
};

const UploadHandler = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MODAL_UPLOAD_ONCLICK':
      return update(state, {
        redirectURL: { $set: action.redirectURL },
        newUploadDocumentType: { $set: action.documentType },
        newUploadSessionHash: { $set: action.sessionHash },
        newUploadSessionKey: { $set: action.sessionKey },
      });
    case 'DISABLE_DEFAULT_DROP_UPLOAD_TRACKING':
      return update(state, {
        defaultDropTrackingDisabled: { $set: true },
      });
    case 'ENABLE_DEFAULT_DROP_UPLOAD_TRACKING':
      return update(state, {
        defaultDropTrackingDisabled: { $set: false },
      });
    default:
      return state;
  }
};

export default UploadHandler;



// WEBPACK FOOTER //
// ./src-react/Upload/UploadReducer.jsx